import React from 'react';
import { CaptionText, grey600, v2black, v2blue400 } from '@paypalcorp/pp-react';
import glamorous from 'glamorous';
import { ThemeProvider } from '@paypalcorp/pp-react-theme';
import styles from './donation-terms.less';
import * as analytics from '../lib/analytics';

const TermsList = glamorous(CaptionText)({
  listStyleType: 'disc',
  '& a': {
    color: v2blue400,
  },
});

const Term = glamorous(CaptionText)({
  margin: '10px 0px 10px 10px',
  '& a': {
    color: v2blue400,
  },
});

const TermsOl = glamorous(CaptionText)({
  listStyleType: 'disc',
  textAlign: 'justify',
});

const defaultTermsKey = 'label.donation-enrolled-terms';

export default function DonationTerms(props) {
  const { charity } = props;
  const termsKey = props.donationTerms || defaultTermsKey;
  let terms = Array.isArray(props.donationTermsOverride)
    ? props.donationTermsOverride
    : props.i18n(termsKey);

  terms = Array.isArray(terms) ? terms : [];
  const shouldJoin = props.join === undefined ? false : props.join;
  if (shouldJoin) {
    return (
      <ThemeProvider theme='v2'>
        <TermsList dangerouslySetInnerHTML={{ __html: terms.join(' ') }} />
      </ThemeProvider>
    );
  }

  const handleClickTerms = (term) => {
    if (!term.includes('<a')) {
      return;
    }

    const { authState } = JSON.parse(
      document.getElementById('data-props').innerHTML
    );
    const { country: contentCountry } = JSON.parse(
      document.getElementById('data-locale').innerHTML
    );

    analytics.instance.recordEvent(
      analytics.events.DW_GIVING_DONATE_SETUP_TERMS_PRESSED,
      {
        e: 'cl',
        account_type: authState === 'ANONYMOUS' ? 'guest' : 'member',
        flow: 'donate to charity',
        product: 'dw_giving',
        component: 'donatenodeweb',
        link_name: term.includes('terms') ? 'terms' : 'conditions',
        ui_type: 'full_page',
        charityname: charity.name || '',
        crid: charity.nonprofit_id || '',
        acct_cntry: contentCountry,
        campaign_id: '-', // Sending dash because this tag is required and in this component we are handling chatiries instead of campaigns
      }
    );
  };

  const isSingleTerm = terms.length === 1;

  return (
    <ThemeProvider theme='v2'>
      <TermsOl
        as={isSingleTerm ? undefined : 'ol'}
        style={{
          color: grey600,
          paddingBottom: isSingleTerm ? '16px' : undefined,
        }}
      >
        {terms.map((term, index) => {
          return (
            <Term
              as={isSingleTerm ? undefined : 'li'}
              key={`donation-term-${index}`}
              className={styles.liTerms}
              style={{ color: v2black }}
              dangerouslySetInnerHTML={{ __html: term }}
              onClick={() => handleClickTerms(term)}
            />
          );
        })}
      </TermsOl>
    </ThemeProvider>
  );
}
